import React from 'react';

export interface CustomIconQrChannelProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

export function CustomIconQrChannel({ width, height, ...props }: CustomIconQrChannelProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        stroke="#1C1C28"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h11.75L21 22V5Z"
        clipRule="evenodd"
      />
      <path fill="#1C1C28" stroke="#1C1C28" strokeWidth="2" d="M16 23v3l3.5-4H17a1 1 0 0 0-1 1Z" />
      <path
        stroke="#1C1C28"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.53"
        d="M11.316 8.474A.474.474 0 0 0 10.842 8H8.474A.474.474 0 0 0 8 8.474v2.368c0 .262.212.474.474.474h2.368a.474.474 0 0 0 .474-.474V8.474ZM17 8.474A.474.474 0 0 0 16.527 8H14.158a.474.474 0 0 0-.473.474v2.368c0 .262.212.474.473.474h2.369a.474.474 0 0 0 .473-.474V8.474ZM11.316 14.158a.474.474 0 0 0-.474-.474H8.474a.474.474 0 0 0-.474.474v2.368c0 .262.212.474.474.474h2.368a.474.474 0 0 0 .474-.474v-2.368Z"
        clipRule="evenodd"
      />
      <path
        fill="#1C1C28"
        d="M13 17.42v-4c0-.231.188-.42.417-.42h1.666a.42.42 0 0 1 .417.42c0 .23.188.418.417.418h.833c.23 0 .25-.188.25-.419 0-.23.188-.419.417-.419a.42.42 0 0 1 .416.42v2.515a.42.42 0 0 1-.416.42h-1.5a.42.42 0 0 1-.417-.42.42.42 0 0 0-.417-.42.42.42 0 0 0-.416.42v1.484a.42.42 0 0 1-.417.42h-.833a.42.42 0 0 1-.417-.42Z"
      />
      <path
        fill="#1C1C28"
        d="M15.622 17.123a.416.416 0 0 1 .711.296.42.42 0 0 1-.416.42.415.415 0 0 1-.417-.42.42.42 0 0 1 .122-.296ZM17.122 17.123a.416.416 0 0 1 .711.296.42.42 0 0 1-.416.42.415.415 0 0 1-.417-.42.42.42 0 0 1 .122-.296Z"
      />
    </svg>
  );
}
